<template>
	<div class="max-w-xs bg-white overflow-hidden rounded shadow-md m-4 p-24 cursor-pointer hover:shadow-lg" 
	@click="showCreateAlbum" v-bind:title="this.createAlbumButtonTitle">

<!-- Generator: Adobe Illustrator 19.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<svg class="w-full h-full" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 42 42" style="enable-background:new 0 0 42 42;" xml:space="preserve">
<path style="fill:#dae1e7;" d="M37.059,16H26V4.941C26,2.224,23.718,0,21,0s-5,2.224-5,4.941V16H4.941C2.224,16,0,18.282,0,21
	s2.224,5,4.941,5H16v11.059C16,39.776,18.282,42,21,42s5-2.224,5-4.941V26h11.059C39.776,26,42,23.718,42,21S39.776,16,37.059,16z"
	/>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
</svg>
	</div>
</template>

<script>

export default {
  name:"NewAlbumButton",
  components: {
  },
  data() {
		return {
			createAlbumButtonTitle: 'Create new album',
		};
	},

	created() {
	},

	methods: {
		showCreateAlbum() {
			this.$root.$emit('onCreateNewAlbum');
		},
	},
}
</script>


// WEBPACK FOOTER //
// src/components/NewAlbumButton.vue